import { Chip, FormHelperText } from "@mui/material";
import { FilePresent } from "@mui/icons-material";
import { BoxSpg, isEmpty, isNotEmpty } from "@duosoftbg/nacid-components";
import { useFormContext, useWatch } from "react-hook-form";
import styled from "styled-components";
import { FieldErrors } from "react-hook-form/dist/types/errors";
import { useTranslation } from "react-i18next";

export const FileUploadHelperText = styled(FormHelperText)`
  font-size: 13px;
  margin-top: 5px;
  margin-left: 5px;
`;

type FileDetailsProps = {
  uploadError?: FieldErrors;
  hint?: string;
};

const FileDetails = ({ uploadError, hint }: FileDetailsProps) => {
  const { t } = useTranslation();
  const { getValues } = useFormContext();

  useWatch({ name: "file" });

  return (
    <BoxSpg mt={3}>
      {!uploadError && isEmpty(getValues().file.fileName) && isNotEmpty(hint) && (
        <BoxSpg style={{ whiteSpace: "pre-line" }}>
          <FileUploadHelperText>{t(hint)}</FileUploadHelperText>
        </BoxSpg>
      )}
      {uploadError && (
        <BoxSpg style={{ whiteSpace: "pre-line" }}>
          <FileUploadHelperText error>
            {(uploadError?.fileId ? uploadError.fileId.message : uploadError.message) as any}
          </FileUploadHelperText>
        </BoxSpg>
      )}
      {isNotEmpty(getValues().file.fileName) ? <Chip icon={<FilePresent />} label={getValues().file.fileName} /> : null}
    </BoxSpg>
  );
};
export default FileDetails;
